var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-ppt-container"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }